import { useState, useEffect } from "react";

const WEBSOCKET_URL = "wss://backendvive-f0ebeuctgsekebbt.norwayeast-01.azurewebsites.net";

export const useWebSocket = (userId) => {
  const [socket, setSocket] = useState(null);
  const [socketState, setSocketState] = useState(false);
  const [socketEvent, setSocketEvent] = useState(null);
  const [socketEventHealth, setSocketEventHealth] = useState(null);
  const [socketEventSettings, setSocketEventSettings] = useState(null);
  const [socketEventBP, setSocketEventBP] = useState(null);
  const [socketEventPulse, setSocketEventPulse] = useState(null);
  const [socketEventSPO2H, setSocketEventSPO2H] = useState(null);
  const [socketEventTemperature, setSocketEventTemperature] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!userId) return;

    let ws = new WebSocket(WEBSOCKET_URL);

    ws.onopen = () => {
      console.log("✅ WebSocket conectado con userId:", userId);
      ws.send(JSON.stringify({ userId }));
      syncSocketState(ws);
    };

    ws.onmessage = (event) => {
      console.log("📡 WebSocket Mensaje Recibido:", event.data);
      try {
        const newMessage = JSON.parse(event.data);
        setSocketEvent(newMessage);

        // ✅ Verificar userId antes de actualizar el estado
        if (newMessage?.settingsAndState && newMessage?.userId === userId) {
          setSocketEventSettings(() => newMessage);
        } else if (newMessage?.payload && newMessage?.payload?.userId === userId) {
          setSocketEventHealth(() => newMessage);

          switch (newMessage?.table) {
            case "userinpressure":
              setSocketEventBP({
                timestampSeconds: newMessage?.payload?.lastEntry,
                bpHigh: newMessage?.payload?.bpHigh,
                bpLow: newMessage?.payload?.bpLow,
              });
              break;
            case "userinfpulse":
              setSocketEventPulse({
                timestampSeconds: newMessage?.payload?.lastEntry,
                pulse: newMessage?.payload?.pulse,
              });
              break;
            case "userinfspo2hvalue":
              setSocketEventSPO2H({
                timestampSeconds: newMessage?.payload?.lastEntry,
                spo2hValue: newMessage?.payload?.Spo2hValue,
              });
              break;
            case "userinftemp":
              setSocketEventTemperature({
                timestampSeconds: newMessage?.payload?.lastEntry,
                temperature: newMessage?.payload?.temperature,
              });
              break;
            default:
              break;
          }
        }
      } catch (err) {
        console.error("❌ Error procesando mensaje WebSocket:", err);
      }
    };

    ws.onerror = (event) => {
      console.error("❌ WebSocket Error:", event);
      setError(event);
      syncSocketState(ws);
    };

    ws.onclose = () => {
      console.warn("⚠ WebSocket desconectado, reconectando...");
      syncSocketState(ws);
      reconnectWebSocket(userId);
    };

    setSocket(ws);

    return () => {
      ws.close();
    };
  }, [userId]);

  // ✅ Función para actualizar el estado de la conexión
  const syncSocketState = (ws) => {
    if (ws && ws.readyState === WebSocket.OPEN) {
      setSocketState(true);
    } else {
      setSocketState(false);
    }
  };

  // ✅ Reconexión automática
  const reconnectWebSocket = (userId) => {
    setTimeout(() => {
      console.log("♻ Reconectando WebSocket...");
      setSocket(new WebSocket(WEBSOCKET_URL));
    }, 3000);
  };

  // ✅ Función para enviar mensajes
  const sendMessage = (message) => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(JSON.stringify(message));
      console.log("📤 Mensaje enviado:", message);
    } else {
      console.warn("⚠ WebSocket no está abierto. No se pudo enviar mensaje.");
    }
  };

  return {
    socket,
    socketState,
    socketEvent,
    socketEventHealth,
    socketEventSettings,
    socketEventBP,
    socketEventPulse,
    socketEventSPO2H,
    socketEventTemperature,
    error,
    sendMessage,
  };
};
